<template>
  <div class="d-flex justify-content-center">
    <b-row class="mt-5 col-12 col-lg-12 col-xl-12">
      <b-col class="col-12 text-center">
        <h1 class="mb-1">{{ $t('creator.jobExpire') }}</h1>
        <p>{{ $t('creator.jobRemoved') }}</p>
        <b-col class="col-12 d-flex mt-2">
          <b-form-datepicker :key="date_key" v-model="casting_call.date_delivery" rows="1" :placeholder="$t('creator.deadline')"></b-form-datepicker>
          <b-button variant="flat-secondary" @click="deleteDate()">
            <feather-icon icon="TrashIcon" size="20"></feather-icon>
          </b-button>
        </b-col>
        <b-col class="col-12 d-flex justify-content-center">
          <b-button variant="blue-button-next-step" class="blue-button-next-step my-2" :disabled="disable_by_location" @click="save()">{{has_slug ? $t('creator.savePreview') : $t('creator.butonNext')}}</b-button>
        </b-col>
      </b-col>
      <small class="mt-2 w-100 text-center text-muted">{{ $t('creator.deadlinePotential') }}</small>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BFormDatepicker,
} from 'bootstrap-vue';
import utils from '@/libs/utils';
import casting_calls_services from '@/services/casting_calls';

export default {
  name: 'stepDeliveryDeadline',
  components: {
    BRow,
    BCol,
    BButton,
    BFormDatepicker,
  },
  props: {
    type_location: {
      type: String,
      default: 'any',
    },
    selected_locations: {
      type: Array,
      default: () => [],
    },
    disable_by_location: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      text: '',
      profile: {},
      utils,
      steps: null,
      casting_call: {},
      casting_call_uuid: '',
      date_key: 0,
    }
  },
  created() {
    this.getData();
  },
  computed: {
    has_slug() {
      return this.$route.params.slug
    }
  },
  methods: {
    getData() {
      if (this.has_slug) {
        this.casting_call = {...this.$route.params.casting_call_data};
        this.casting_call_uuid = this.casting_call.uuid;
      } else {
        this.steps = JSON.parse(localStorage.getItem('steps'));
        this.casting_call.date_delivery = this.steps?.date_delivery ? new Date(this.steps.date_delivery) : null;
      }
    },
    deleteDate() {
      this.casting_call.date_delivery = null
      this.date_key += 1;
    },
    setSteps() {
      this.steps['type_location'] = this.type_location;
      this.steps['selected_locations'] = this.type_location === "specific" ? this.selected_locations : [];
      this.steps['date_delivery'] = this.casting_call.date_delivery;

      localStorage.setItem('steps', JSON.stringify(this.steps));
    },
    save() {
      if (this.has_slug) {
        const form_data = {
          remove_date_delivery: this.casting_call.date_delivery === null,
          remove_location: this.type_location === 'any',
          location: this.selected_locations.map((location) => location.name),
        };
        if (this.casting_call.date_delivery) {
          form_data.date_delivery = new Date(this.casting_call.date_delivery).toISOString();
        }

        casting_calls_services.updateCastingCall(this.casting_call_uuid, form_data).then(() => {
          localStorage.removeItem('steps');
          this.$root.$emit('quit_navbar_white');
          this.$router.push({name: 'view_casting_call', params: {slug: this.$route.params.slug}})
        })
      } else {
        this.setSteps();
        this.$router.push({ name: 'steps_casting_call', params: {step: 'cover-image'} });
      }
    },
  }
}
</script>